export const    ITEM = 'ITEM';
export const    ITEM_SUCCESS = 'ITEM_SUCCESS';
export const    ITEM_ERROR = 'ITEM_ERROR';

export const    ITEM_DATE = 'ITEM_DATE';
export const    ITEM_DATE_SUCCESS = 'ITEM_DATE_SUCCESS';
export const    ITEM_DATE_ERROR = 'ITEM_DATE_ERROR';

export const    ADD_ITEM = 'ADD_ITEM';
export const    ADD_ITEM_SUCCESS = 'ADD_ITEM_SUCCESS';
export const    ADD_ITEM_ERROR = 'ADD_ITEM_ERROR';

export const    UPDATE_ITEM = 'UPDATE_ITEM';
export const    UPDATE_ITEM_SUCCESS = 'UPDATE_ITEM_SUCCESS';
export const    UPDATE_ITEM_ERROR = 'UPDATE_ITEM_ERROR';



export const DELETE_ITEM = 'DELETE_ITEM';
export const DELETE_ITEM_SUCCESS= 'DELETE_ITEM_SUCCESS';
export const DELETE_ITEM_ERROR ='DELETE_ITEM_ERROR';

export const ITEMICON = 'ITEMICON';
export const ITEMICON_SUCCESS= 'ITEMICON_SUCCESS';
export const ITEMICON_ERROR = 'ITEMICON_ERROR';